<tt-page>
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-list [ttData]="filteredOrders" ttBackStyle [ttGoto]="false" (ttClick)="select($event.item)"></tt-list>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="selectpofinish_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <tt-card class="col-xs-12 p-5">
                        <ng-container *ngTemplateOutlet="info"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50">
                    <tt-list class="col-xs-12 p-5" [ttData]="filteredOrders" ttBackStyle [ttGoto]="false" (ttClick)="select($event.item)"></tt-list>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </ng-container>

    <p *ngIf="error" role="alert">{{ error }}</p>
</tt-page>

<ng-template #info>
    <ng-container>
        <tt-tabs [ttSelectedId]="openOption" (ttSelectedIdChange)="changeOpenOption($event)">
            <tt-tab ttId="selectpofinish_open" ttLabel="selectpofinish_open"></tt-tab>
            <tt-tab ttId="selectpofinish_notopen" ttLabel="selectpofinish_notopen"></tt-tab>
        </tt-tabs>

        <tt-tabs *ngIf="openOption === 'selectpofinish_open'" [ttSelectedId]="finishOption" (ttSelectedIdChange)="changeFinishOption($event)">
            <tt-tab ttId="selectpofinish_open_mine" ttLabel="selectpofinish_open_mine"></tt-tab>
            <tt-tab ttId="selectpofinish_open_other" ttLabel="selectpofinish_open_other"></tt-tab>
        </tt-tabs>

        <ng-container *ngIf="openOption === 'selectpofinish_notopen'">
            <tt-input ttLabel="stockplace_name" [ttModel]="page.stockplace_name" ttReadonly></tt-input>
            <tt-input ttLabel="operation_name" [ttModel]="page.operation_name" ttReadonly></tt-input>
        </ng-container>

        <tt-input ttLabel="search" [(ttModel)]="page.filtervalue" ttShowClearButton></tt-input>
    </ng-container>
</ng-template>
